import { render, staticRenderFns } from "./Otofuda.vue?vue&type=template&id=0330b428&scoped=true&"
import script from "./Otofuda.vue?vue&type=script&lang=js&"
export * from "./Otofuda.vue?vue&type=script&lang=js&"
import style0 from "./Otofuda.vue?vue&type=style&index=0&id=0330b428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0330b428",
  null
  
)

export default component.exports